var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeneficiaryWithWhiteCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 525,
    height: 525,
    viewBox: "0 0 525 525",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_267",
    x: 0,
    y: 0,
    width: 525,
    height: 525,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "beneficiary_with_white_circle",
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6519",
    "data-name": "Group 6519"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2359",
    "data-name": "Group 2359",
    transform: "translate(-211 -211)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 209.5, 209.5)",
    filter: "url(#Ellipse_267)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_267-2",
    "data-name": "Ellipse 267",
    cx: 246,
    cy: 246,
    r: 246,
    transform: "translate(11.5 11.5)",
    fill: "rgba(255,255,255,0.71)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(-1090.16 -316.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2610",
    "data-name": "Path 2610",
    d: "M73.085,25.273.661,47.976,73.085,279.3l21.993,70.382H208.344l21.607-6.776,24.995-7.775-24.905-79.8L150.419,1.046Z",
    transform: "translate(1209.499 397.358)",
    fill: "#3b965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2612",
    "data-name": "Path 2612",
    d: "M179.918,285.331l5.42,17.285-69.125,21.6-5.42-17.285L93.51,312.357,14.23,58.906l17.285-5.42L26.093,36.2,95.208,14.607l5.42,17.283,17.285-5.42L197.2,279.911Z",
    transform: "translate(1231.6 419.443)",
    fill: "#4baf71"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3156",
    "data-name": "Rectangle 3156",
    width: 156.879,
    height: 350,
    transform: "translate(1281.241 397.04)",
    fill: "#3b965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2615",
    "data-name": "Path 2615",
    d: "M122.785,270.424v16.239H55.027V270.345H38.1V31.4H55.048V15.085h67.758V31.4h16.951V270.424l-16.951.079Z",
    transform: "translate(1270.47 420.222)",
    fill: "#4baf71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2617",
    "data-name": "Path 2617",
    d: "M76.447,55.024a30.67,30.67,0,1,1-30.67,30.67,30.67,30.67,0,0,1,30.67-30.67",
    transform: "translate(1282.971 485.264)",
    fill: "#3b965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2619",
    "data-name": "Path 2619",
    d: "M114.281,204.214a22.873,22.873,0,0,1-22.76-22.981V168.39a1.955,1.955,0,0,0-.465-1.3l-25.071-32.6a17.871,17.871,0,0,1,2.91-24.782,17.473,17.473,0,0,1,23.425,1.3l31.824,32.136a2.09,2.09,0,0,0,2.224.455,2.033,2.033,0,0,0,1.254-1.921V47.59L155.87,99.911a23.311,23.311,0,0,1,2.776,11.04V243.957a2.04,2.04,0,0,1-2.021,2.066H119.4a2.043,2.043,0,0,1-2.056-2.032V207.447a3.21,3.21,0,0,0-3.11-3.223Z",
    transform: "translate(1309.843 473.158)",
    fill: "#f6d5a0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3157",
    "data-name": "Rectangle 3157",
    width: 72.834,
    height: 53.357,
    transform: "translate(1410.217 693.681)",
    fill: "#de2a33"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_465",
    "data-name": "Ellipse 465",
    cx: 5.321,
    cy: 5.73,
    rx: 5.321,
    ry: 5.73,
    transform: "translate(1458.229 699.888)",
    fill: "#f9f9f9"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3961",
    "data-name": "Rectangle 3961",
    width: 512,
    height: 512,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeneficiaryWithWhiteCircle);
export default __webpack_public_path__ + "static/media/beneficiary_with_white_circle.b314a4459ac13d21db59955336040973.svg";
export { ForwardRef as ReactComponent };